import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const retryableLazy = (factory) => React.lazy(async () => {
    while (true) {
        try {
            const timeout = async () => {
                await sleep(5000);
                throw Error('Lazy import timeout');
            };
            return await Promise.race([factory(), timeout()]);
        }
        catch (e) {
            datadogRum.addError(e);
            await sleep(1000);
        }
    }
});
